"use client";

import { useState } from "react";
import CategoryTag from "./CategoryTag";

const ACCENT = "#FF5D31";

export default function ArticleCard({ article, onToggleRelevance }) {
  const [hovered, setHovered] = useState(false);
  const isFiltered = article.classification && !article.classification.relevant;

  return (
    <div
      style={{
        padding: "16px 20px",
        backgroundColor: "#f7f3ea",
        borderRadius: "4px",
        border: "1px solid #999",
        opacity: isFiltered ? 0.45 : 1,
        transition: "opacity 0.3s",
        position: "relative",
      }}
    >
      {isFiltered && (
        <div
          style={{
            position: "absolute",
            top: "8px",
            right: "12px",
            fontSize: "9px",
            fontFamily: "var(--font-mono)",
            color: "#D65C3B",
            textTransform: "uppercase",
            letterSpacing: "0.8px",
          }}
        >
          filtered
        </div>
      )}

      {article.classification && (
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
          <span
            style={{
              fontSize: "11px",
              fontFamily: "var(--font-mono)",
              color: article.classification.relevant ? "#43695B" : "#D65C3B",
              fontWeight: 500,
            }}
          >
            {article.classification.relevant ? "\u2713" : "\u2717"}
          </span>
          <CategoryTag category={article.classification.category} />
          <span
            style={{
              fontSize: "10px",
              fontFamily: "var(--font-mono)",
              color: "#999999",
            }}
          >
            {article.classification.confidence}
          </span>
          {article.manualOverride && (
            <span
              style={{
                fontSize: "9px",
                fontFamily: "var(--font-mono)",
                color: "#8B6914",
                backgroundColor: "#FDF6E3",
                padding: "1px 6px",
                borderRadius: "3px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                fontWeight: 600,
              }}
            >
              Manual
            </span>
          )}
          {onToggleRelevance && (
            <button
              onClick={() => onToggleRelevance(article.id, !article.classification.relevant)}
              style={{
                marginLeft: "auto",
                padding: "2px 8px",
                borderRadius: "3px",
                border: "1px solid #DCD6C7",
                backgroundColor: "#fff",
                color: article.classification.relevant ? "#D65C3B" : "#43695B",
                fontSize: "10px",
                fontFamily: "var(--font-mono)",
                fontWeight: 500,
                cursor: "pointer",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              {article.classification.relevant ? "Exclude" : "Include"}
            </button>
          )}
        </div>
      )}

      <a
        href={article.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: hovered ? ACCENT : "#1B1B1A",
          textDecoration: "none",
          fontSize: "16px",
          fontFamily: "var(--font-serif)",
          fontWeight: 600,
          lineHeight: 1.35,
          display: "block",
          marginBottom: "5px",
          transition: "color 0.15s",
        }}
        onMouseOver={() => setHovered(true)}
        onMouseOut={() => setHovered(false)}
      >
        {article.title}
      </a>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          marginBottom: "6px",
          fontSize: "12px",
          fontFamily: "var(--font-mono)",
          color: "#999999",
        }}
      >
        <span style={{ color: "#70706E" }}>{article.source}</span>
        {article.author && article.author !== "Staff" && (
          <>
            <span>&middot;</span>
            <span style={{ fontStyle: "italic", color: "#70706E" }}>{article.author}</span>
          </>
        )}
        <span>&middot;</span>
        <span>{article.date}</span>
      </div>

      <p
        style={{
          color: "#464644",
          fontSize: "13px",
          lineHeight: 1.55,
          margin: 0,
          fontFamily: "var(--font-sans)",
        }}
      >
        {article.snippet}
      </p>

      {article.classification?.reason && (
        <div
          style={{
            marginTop: "8px",
            padding: "6px 10px",
            backgroundColor: article.manualOverride ? "#FDF6E3" : "#FAF7F5",
            borderRadius: "3px",
            fontSize: "11px",
            fontFamily: "var(--font-mono)",
            color: "#999999",
            borderLeft: `3px solid ${article.classification.relevant ? "#43695B" : "#D65C3B"}30`,
          }}
        >
          {article.manualOverride ? "Manual override" : `AI: ${article.classification.reason}`}
        </div>
      )}
    </div>
  );
}
